export const APP_BASE_URL = '';

export const MESSAGE_STATUS = {
  FAILED: 'failed',
  SUCCESS: 'success',
  PROGRESS: 'progress',
};

export const MESSAGE_TYPE = {
  INCOMING: 0,
  OUTGOING: 1,
  ACTIVITY: 2,
  TEMPLATE: 3,
};

// Префикс postMessage между виджетом и страницей сайта. Родитель сообщает
// свою версию параметром sdk_protocol=dialog в адресе iframe: если параметра
// нет, на странице лежит старый закэшированный sdk.js (Cache-Control на год),
// и говорить с ним надо прежним префиксом — иначе виджет откроется и замолчит.
const LEGACY_WIDGET_PREFIX = 'chatwoot-widget:';
const DIALOG_WIDGET_PREFIX = 'dialog-widget:';

const parentSpeaksDialogProtocol = () => {
  try {
    return (
      new URLSearchParams(window.location.search).get('sdk_protocol') ===
      'dialog'
    );
  } catch {
    return false;
  }
};

export const WOOT_PREFIX = parentSpeaksDialogProtocol()
  ? DIALOG_WIDGET_PREFIX
  : LEGACY_WIDGET_PREFIX;
